import React, { FC } from 'react';
import { getImageData } from './utils';

interface ImageProps {
  srcset: string[];
  alt: string;
  responsiveImageData: {
    sizes: string[];
    srcSet: number[];
  };
  lazyLoad?: boolean;
}

export const Image: FC<ImageProps> = ({ srcset: srcsetDefault, alt, responsiveImageData, lazyLoad = false }) => {
  if (!srcsetDefault[0]) {
    return null;
  }

  const responsiveData = getImageData(srcsetDefault[0], responsiveImageData);
  const srcset = responsiveData.srcset;
  const sizes = responsiveData.sizes;
  const commonAttributes = {
    alt,
    ...(lazyLoad && { loading: 'lazy' as const }),
  };
  const img =
    srcset.length > 1 ? (
      <img
        srcSet={srcset.join(', ')}
        sizes={sizes.join(', ')}
        src={srcset[srcset.length - 1].split(' ').shift()}
        {...commonAttributes}
      />
    ) : (
      <img src={srcset[0].split(' ').shift()} {...commonAttributes} />
    );

  return img;
};
